import React from 'react';
import { useUser } from '@clerk/clerk-react';
import { Navigate, useLocation } from 'react-router-dom';
import { setUser } from '@/hooks/authHelpers';
import { Loader2 } from "lucide-react";
import * as Sentry from "@sentry/react";

const PrivateRoute = ({ adminOnly, children, redirectTo = "/login" }) => {
    const { isSignedIn, user, isLoaded } = useUser();
    const location = useLocation();

    if (!isLoaded) {
        return (
            <div className="fixed inset-0 flex items-center justify-center bg-background">
                <div className="flex flex-col items-center space-y-4">
                    <Loader2 className="h-12 w-12 animate-spin text-primary" />
                </div>
            </div>
        );
    }

    if (!isSignedIn) {
        return <Navigate to={redirectTo} state={{ from: location }} />;
    }

    Sentry.setUser({
        id: user.id,
        email: user.primaryEmailAddress?.emailAddress || "",
    });

    setUser(user);

    if (adminOnly && user?.publicMetadata?.role !== 'admin') {
        return <Navigate to="/unauthorized" />;
    }

    return children;
};

export default PrivateRoute;
